module.exports = __webpack_public_path__ + "static/media/ucd.27258adc.png";